<template>
  <div class="EventTypeSettings">
    <VSkeletonLoader
      :loading="loading"
      :types="{
        select: 'button',
        'event-type-settings-row': 'text, select, select, select',
        'event-type-settings': 'event-type-settings-row@8'
      }"
      type="event-type-settings"
    >
      <div v-if="loading">
        <!-- Требуется из-за говнокода в VSkeletonLoader,
             а именно computed-свойство isLoading -->
        Loading...
      </div>

      <VCard
        dense
        class="mb-1"
        :class="'elevation-' + ($vuetify.breakpoint.smAndDown ? 1 : 0)"
      >
        <VCardText>
          <VRow
            dense
            class="event-type-row"
          >
            <template v-if="!ui.showNewTypeForm">
              <VCol class="flex-grow-1 d-flex align-center">
                <VBtn
                  color="primary"
                  title="Сохранить"
                  text
                  @click="ui.showNewTypeForm = true"
                >
                  <VIcon v-text="'mdi-plus'" />
                  Добавить новый тип события
                </VBtn>
              </VCol>
            </template>
            <template v-else>
              <VCol class="flex-grow-0 d-flex align-end">
                <VBtn
                  color="primary"
                  title="Сохранить"
                  icon
                  @click="saveNewType()"
                >
                  <VIcon v-text="'mdi-check'" />
                </VBtn>
              </VCol>
              <VCol
                cols="12"
                md="auto"
                class="flex-md-grow-1"
              >
                <VTextField
                  :value="model.newType.name"
                  label="Новый тип"
                  :loading="ui.savingNewType"
                  hide-details
                  @change="model.newType.name = $event.slice(0, 255) || 'Новый тип'"
                  @keydown.enter="saveNewType()"
                />
              </VCol>
              <VCol style="flex-grow: 0; min-width: 175px">
                <VCombobox
                  :value="model.newType.categoryName"
                  label="Категория"
                  :items="sortedCategories"
                  :loading="ui.savingNewType"
                  item-value="name"
                  item-text="name"
                  hide-details
                  @change="
                    $event && $event.name
                      ? model.newType.categoryName = $event.name
                      : getOrCreateCategory($event)"
                />
              </VCol>
              <VCol style="flex-grow: 0; min-width: 150px">
                <ColorPicker
                  v-model="model.newType.color"
                  label="Цвет"
                  :loading="ui.savingNewType"
                />
              </VCol>
              <!--VCol style="flex-grow: 0; min-width: 165px">
                <VSwitch
                  v-model="model.newType.expand"
                  :loading="ui.savingNewType"
                  hide-details
                  label="Растягивать"
                />
              </VCol-->
              <VCol class="flex-grow-0 d-flex align-end">
                <VBtn
                  color="primary"
                  title="Отмена"
                  icon
                  @click="ui.showNewTypeForm = false"
                >
                  <VIcon v-text="'mdi-close'" />
                </VBtn>
              </VCol>
            </template>
          </VRow>
        </VCardText>
      </VCard>

      <Draggable
        tag="div"
        :value="effectiveOrder"
        animation="200"
        group="eventTypes"
        handle=".handle"
        @start="ui.drag = true"
        @end="ui.drag = false"
        @change="updateDraggableValue($event)"
      >
        <transition-group
          tag="div"
          name="drag-transition"
        >
          <VCard
            v-for="eventType in sortedEventTypes"
            :key="eventType.code"
            dense
            class="mb-4 mb-md-0"
            :class="'elevation-' + ($vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly ? 1 : 0)"
          >
            <VCardText>
              <!--pre>{{ eventType }}</pre-->
              <VRow
                v-if="!loading"
                dense
                class="event-type-row"
              >
                <VCol class="flex-grow-0 d-flex align-end mb-1">
                  <VIcon
                    class="handle"
                    style="cursor: pointer"
                    title="Перетаскивайте для изменения порядка"
                    v-text="'mdi-drag'"
                  />
                </VCol>
                <VCol
                  cols="12"
                  md="auto"
                  class="flex-md-grow-1"
                >
                  <VTextField
                    label="Название"
                    :append-outer-icon="isNonDefault(eventType.code, 'name') ? 'mdi-restore' : undefined"
                    :value="formValues[eventType.code]['name']"
                    :loading="!!modelValue(eventType.code, 'name')"
                    hide-details
                    @change="setModelValue(eventType.code, 'name', $event.slice(0, 255))"
                    @click:append-outer="resetToDefault(eventType.code, 'name')"
                    @blur="formValues[eventType.code]['name'] === '' && resetModelValue(eventType.code, 'name')"
                  />
                </VCol>
                <VCol style="flex-grow: 0; min-width: 175px">
                  <VCombobox
                    label="Категория"
                    :value="formValues[eventType.code]['categoryName']"
                    :items="sortedCategories"
                    :append-outer-icon="isNonDefault(eventType.code, 'categoryCode') ? 'mdi-restore' : undefined"
                    :loading="!!modelValue(eventType.code, 'categoryCode')"
                    item-value="name"
                    item-text="name"
                    hide-details
                    @change="
                      $event && $event.code
                        ? setModelValue(eventType.code, 'categoryCode', $event.code)
                        : updateCategory(eventType.code, $event)"
                    @click:append-outer="
                      isNonDefault(eventType.code, 'categoryCode')
                        ? resetToDefault(eventType.code, 'categoryCode')
                        : undefined"
                  />
                </VCol>
                <VCol style="flex-grow: 0; min-width: 150px">
                  <ColorPicker
                    label="Цвет"
                    :value="formValues[eventType.code]['color']"
                    :loading="!!modelValue(eventType.code, 'color')"
                    :append-outer-icon="isNonDefault(eventType.code, 'color') ? 'mdi-restore' : undefined"
                    @click:append-outer="resetToDefault(eventType.code, 'color')"
                    @change="setModelValue(eventType.code, 'color', $event)"
                  />
                </VCol>
                <!--VCol style="flex-grow: 0; min-width: 165px">
                  <VSwitch
                    :input-value="formValues[eventType.code]['expand']"
                    :loading="modelValue(eventType.code, 'expand') != null"
                    hide-details
                    @change="setModelValue(eventType.code, 'expand', $event)"
                  >
                    <template #label>
                      Растягивать
                      <VBtn
                        v-if="isNonDefault(eventType.code, 'expand')"
                        icon
                        x-small
                        title="Установить значение по умолчанию"
                        @click.stop="resetToDefault(eventType.code, 'expand')"
                      >
                        <VIcon>mdi-restore</VIcon>
                      </VBtn>
                    </template>
                  </VSwitch>
                </VCol-->
                <VCol class="flex-grow-0 d-flex align-end">
                  <VBtn
                    v-if="eventType.isCustomType"
                    title="Удалить"
                    :color="$vuetify.breakpoint.mdAndUp ? 'red darken-2' : 'red darken-4'"
                    :dark="$vuetify.breakpoint.smAndDown"
                    :icon="$vuetify.breakpoint.mdAndUp"
                    @click="removeCustomType(eventType.code)"
                  >
                    <VIcon v-text="'mdi-delete'" />
                    <span class="d-md-none">Удалить</span>
                  </VBtn>
                  <VBtn
                    v-else
                    :disabled="!showRestoreButton(eventType.code)"
                    color="gray"
                    :title="showRestoreButton(eventType.code) ? 'Сбросить всё' : undefined"
                    :icon="$vuetify.breakpoint.mdAndUp"
                    @click="resetAll(eventType.code)"
                  >
                    <VIcon v-text="'mdi-restore'" />
                    <span class="d-md-none">Сбросить всё</span>
                  </VBtn>
                </VCol>
              </VRow>
            </VCardText>
          </VCard>
        </transition-group>
      </Draggable>
      <!--VCard>
        <VCardText>
          <VRow>
            <VCol><pre>Effective: {{ eventTypes }}</pre></VCol>
            <VCol><pre>Categories: {{ categories }}</pre></VCol>
          </VRow>
        </VCardText>
      </VCard-->
    </VSkeletonLoader>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import * as R from 'ramda'
import slugify from 'unicode-slug'

import { ifNil } from '../helpers'
import ColorPicker from './ColorPicker'

const defaultNewType = () => ({
  name: 'Новый тип',
  color: '#ff0000',
  expand: false,
  categoryName: 'Важные события',
})

export default {
  name: 'EventTypeSettings',
  components: {
    ColorPicker,
    Draggable,
  },
  data() {
    return {
      model: {
        // e.g.: { 'email-read': { color: '#ffffff' } }
        overrides: {},
        newType: defaultNewType(),
      },
      ui: {
        drag: false,
        uiOrder: null,
        savingNewType: false,
        showNewTypeForm: false,
      },
    }
  },
  computed: {
    // Типы с учетом настроек
    eventTypes() { return this.$store.state.eventType.map },
    // Настройки по умолчанию
    defaults() { return this.$store.state.eventType.defaults },
    // Имеющиеся категории
    categories() { return this.$store.state.category.map },
    loading() {
      const { eventTypes, defaults, categories } = this
      return eventTypes === null || defaults === null || categories === null
    },
    sortedEventTypes() { return this.$store.getters['eventType/sorted'] },
    sortedCategories() { return this.$store.getters['category/sorted'] },
    formValues() {
      const { sortedEventTypes, formValue, modelValue, categories } = this
      return Object.fromEntries(
        sortedEventTypes
          .map(({ code, categoryCode }) => ([code, {
            color: formValue(code, 'color'),
            categoryName: categories[modelValue(code, 'categoryCode') || categoryCode].name,
            name: formValue(code, 'name'),
            expand: formValue(code, 'expand'),
          }]))
      )
    },
    effectiveOrder() {
      const { sortedEventTypes: types } = this
      return types && types.map(et => et.code)
    },
  },
  watch: {
    'model.overrides': {
      handler() {
        this.$nextTick(this.save)
      },
      deep: true,
    },
  },
  created() {
    this.$store.dispatch('eventType/get', { reload: true })
    this.$store.dispatch('eventType/getDefaults', { reload: true })
    this.$store.dispatch('category/get', { reload: true })
  },
  methods: {
    modelValue(code, propName) {
      const { model: { overrides } } = this
      return overrides[code] && overrides[code][propName]
    },
    effectiveValue(code, propName) {
      const { eventTypes } = this
      return eventTypes[code][propName]
    },
    defaultValue(code, propName) {
      const { defaults, effectiveValue, eventTypes } = this
      return eventTypes[code].isCustomType
        ? effectiveValue(code, propName)
        : defaults[code][propName]
    },
    formValue(code, propName) {
      const { modelValue, effectiveValue } = this

      return R.ifElse(
        R.isNil,
        () => effectiveValue(code, propName),
        R.identity,
      )(modelValue(code, propName))
    },
    isNonDefault(code, propName) {
      const { effectiveValue, defaultValue } = this
      return effectiveValue(code, propName) !== defaultValue(code, propName)
    },
    showRestoreButton(code) {
      const { eventTypes, isNonDefault } = this
      return (
        eventTypes[code].isCustomType ||
        isNonDefault(code, 'name') ||
        isNonDefault(code, 'categoryCode') ||
        isNonDefault(code, 'color') ||
        isNonDefault(code, 'expand')
      )
    },
    setModelValue(code, propName, value) {
      const { effectiveValue, model: { overrides } } = this

      if (effectiveValue(code, propName) === value) {
        this.resetModelValue(code, propName)
      } else {
        if (!overrides[code]) {
          this.$set(overrides, code, {})
        }
        this.$set(overrides[code], propName, value)
      }
    },
    resetModelValue(code, propName) {
      const { model: { overrides } } = this

      if (overrides[code]) {
        this.$delete(overrides[code], propName)
        if (Object.keys(overrides[code]).length === 0) {
          this.$delete(overrides, code)
        }
      }
    },
    resetToDefault(code, propName) {
      const { setModelValue, defaultValue } = this
      setModelValue(code, propName, defaultValue(code, propName))
    },
    resetAll(code) {
      const { eventTypes, resetToDefault } = this
      if (eventTypes[code].isCustomType) {
        throw new Error('custom types cannot be reset')
      }
      resetToDefault(code, 'name')
      resetToDefault(code, 'categoryCode')
      resetToDefault(code, 'color')
      resetToDefault(code, 'expand')
    },
    removeCustomType(code) {
      const { $store, eventTypes } = this
      const eventType = eventTypes[code]

      if (!eventTypes[code].isCustomType) {
        throw new Error('only custom types can be deleted')
      }
      if (!confirm(`Удалить тип события "${eventType.name}"?`)) return
      $store.dispatch('eventType/remove', { code })
        .catch(() => {
          alert('Невозможно удалить тип. Если вы уже создавали события ' +
            'с данным типом, то он защищен от удаления. ' +
            'Пожалуйста обратитесь в техническую поддержку.')
        })
    },
    findCategory(name) {
      return Object.values(this.categories).find(c => c.name === name) || null
    },
    getOrCreateCategory(name) {
      const { findCategory, createCategory } = this
      const existingCategory = findCategory(name)
      return existingCategory
        ? Promise.resolve(existingCategory)
        : createCategory(name)
    },
    createCategory(name) {
      const { $store, findCategory } = this
      return $store.dispatch('category/add', {
        category: { name, code: slugify(name) },
      })
        .then(() => findCategory(name))
    },
    updateCategory(eventTypeCode, categoryName) {
      const { getOrCreateCategory, setModelValue, resetModelValue } = this

      if (!categoryName) {
        resetModelValue(eventTypeCode, 'categoryCode')
        return
      }

      getOrCreateCategory(categoryName)
        .then(({ code }) => setModelValue(eventTypeCode, 'categoryCode', code))
        .catch(e => alert(`Ошибка сохранения категории: ${e.message}`))
    },
    save() {
      const {
        $store,
        eventTypes,
        model: { overrides },
        createCategory,
        save,
        categories,
      } = this

      Object.entries(overrides)
        .forEach(([code, overrides]) => {
          const effective = eventTypes[code]
          $store.dispatch('eventType/set', {
            eventType: {
              code,
              name: overrides.name || effective.name,
              categoryCode: overrides.categoryCode || effective.categoryCode,
              color: overrides.color || effective.color,
              expand: ifNil(() => effective.expand)(overrides.expand),
            },
          })
            .then(() => {
              const newValues = this.eventTypes[code]
              this.setModelValue(code, 'name', newValues.name)
              this.setModelValue(code, 'categoryCode', newValues.categoryCode)
              this.setModelValue(code, 'color', newValues.color)
              this.setModelValue(code, 'expand', newValues.expand)
            })
            .catch(e => {
              const eData = R.path(['reason', 'response', 'data', 'error'])(e)
              if (eData && eData.categoryCode) {
                const categoryName = categories[overrides.categoryCode].name
                if (!categoryName) throw e
                return createCategory(categoryName)
                  .then(save)
              }
              throw e
            })
        })
    },
    saveNewType() {
      const {
        $store,
        model: { newType: { color, name, expand, categoryName } },
        getOrCreateCategory,
        createCategory,
        save,
        categories,
      } = this
      const code = slugify(name)
      this.ui.savingNewType = true
      getOrCreateCategory(categoryName)
        .then(category => $store.dispatch('eventType/set', {
          eventType: {
            code,
            name,
            categoryCode: category.code,
            color,
            expand,
          },
        }))
        .then($store.dispatch('eventType/get', { reload: true }))
        .then(() => this.$nextTick())
        .then(() => {
          const newValues = this.eventTypes[code]
          this.setModelValue(code, 'name', newValues.name)
          this.setModelValue(code, 'categoryCode', newValues.categoryCode)
          this.setModelValue(code, 'color', newValues.color)
          this.setModelValue(code, 'expand', newValues.expand)
          this.ui.showNewTypeForm = false
          this.model.newType = defaultNewType()
        })
        .catch(e => {
          const eData = R.path(['reason', 'response', 'data', 'error'])(e)
          if (eData && eData.categoryCode) {
            const { overrides } = this.model
            const categoryName = categories[overrides.categoryCode].name
            if (!categoryName) throw e
            return createCategory(categoryName)
              .then(save)
          }
          throw e
        })
        .finally(() => { this.ui.savingNewType = false })
    },
    updateDraggableValue({ moved: { newIndex, oldIndex } }) {
      const { $store, effectiveOrder } = this
      $store.dispatch('eventType/reorder', {
        codes: R.move(oldIndex, newIndex, effectiveOrder),
      })
    },
  },
}
</script>

<style lang="sass" scoped>
  .v-skeleton-loader
    ::v-deep &__select > .v-skeleton-loader__button
        width: 100%
    ::v-deep &__event-type-settings
      &-row
        background: white
        padding: 8px 16px
        display: flex
        justify-content: space-between
        align-items: center

        .v-skeleton-loader__text
          flex: 0 0 calc(50% - 8px)
        .v-skeleton-loader__select
          flex: 0 0 calc(16.666667% - 8px)
  .v-text-field, .ColorPicker
    ::v-deep .v-input__append-inner, ::v-deep .v-input__prepend-inner
      cursor: pointer !important
</style>
